module.exports = __webpack_public_path__ + "stylesheets/drag-item_d85de153a9841d04cb7a1dcd10d44e64.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/drag-drop/drag-item.less
// module id = lwEL
// module chunks = 151